import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

// Pale-blue page title banner used across inner pages (matches original)
export const PageBanner = ({ title, subtitle }) => (
  <section className="bg-sky-band">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 text-center">
      <h1 className="font-heading font-light text-navy text-3xl sm:text-4xl md:text-5xl tracking-wide fade-up">{title}</h1>
      {subtitle && <p className="mt-3 text-navy/70 text-base sm:text-lg fade-up">{subtitle}</p>}
    </div>
  </section>
);

const Layout = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
